import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MessagingService } from './services/messages.services';
import { NotificationsClientService } from './services/notifications-client.service';
import { NotificationHealthService } from './services/notification-health.service';
import { UserNotificationsComponent } from './components/user-notifications/user-notifications.component';
import { NotificationDetailDialogComponent } from './components/user-notifications/notification-detail-dialog/notification-detail-dialog.component';
import { NotificationPermissionGuideDialogComponent } from './components/user-notifications/notification-permission-guide-dialog/notification-permission-guide-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        MatDialogModule,
        MatTooltipModule
    ],
    declarations: [
        UserNotificationsComponent,
        NotificationDetailDialogComponent,
        NotificationPermissionGuideDialogComponent
    ],
    exports: [
        UserNotificationsComponent
    ],
    entryComponents: [
        NotificationDetailDialogComponent,
        NotificationPermissionGuideDialogComponent
    ]
})
export class NotificationsModule {
    static forRoot(): ModuleWithProviders<NotificationsModule> {
        return {
            ngModule: NotificationsModule,
            providers: [
                MessagingService,
                NotificationsClientService,
                NotificationHealthService
            ]
        };
    }
}
